import { NEW_CART_PAGE } from 'config/Urls.config';

export const getCartPageUrl = (
  storeId: string,
  language: string,
  isCartRevampEnabled?: boolean
): string => {
  return isCartRevampEnabled ? `/${storeId}/${language}${NEW_CART_PAGE}` : NEW_CART_PAGE;
};
